module.exports = __webpack_public_path__ + "img/snow.c41321c8.png";